export default __webpack_public_path__ + "images/alerts.2e399aa128244be0ac43dc9ed3f65d47.svg";